import { ApplicationErrorType } from './types';
import ApplicationError from './ApplicationError';
import { useRouteError } from 'react-router';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';

interface ApplicationRouterErrorBoundaryProps {
	applicationErrorType: ApplicationErrorType;
}

/**
 * Error Boundary for managing errors caught by the Application Router while rendering routes.
 */
export default function ApplicationRouterErrorBoundary(props: ApplicationRouterErrorBoundaryProps) {
	const error = useRouteError();
	const appInsights = useAppInsightsContext();

	if (error) {
		appInsights.trackException(error);
	}

	return <ApplicationError type={props.applicationErrorType} />;
}
